import React from 'react';
import { speakSegment } from '../speakSegment';
import { VowelChart } from '../chart/VowelChart';
import { FormantsChart } from '../chart/FormantsChart';

/** show the IPA vowels supported through eSpeak */
export function SupportedVowels() {
  return (<div style={{ display: 'grid' }}>
    <div className='cell21'>
      <VowelChart showFrontBack={true} lookup={(ipa) => ipa} clicked={speakSegment} />
    </div>
    <div className='cell22'>
      <FormantsChart width={400} height={220} clicked={speakSegment} />
    </div>
  </div>);
}
